import { useTranslate } from "hooks/useTranslate";

export const useGetSubnavItemTitle = (objClass: string) => {
  const translate = useTranslate();

  switch (objClass) {
    case "ProjectList":
      return translate("MY_PROJECTS");
    case "ProjectListSame":
      return translate("MY_PROJECTS");
    case "ProjectConfigurator":
      return translate("PROJECT_STRUCTURE");
    case "ProjectItem":
      return translate("PROJECT_DETAILS");
    case "ProjectItemSame":
      return translate("PROJECT_DETAILS");
    case "ProductList":
      return translate("PROJECT_PRODUCT_LIST");
    case "LibraryList":
      return translate("LEFT_SIDEBAR_LIBRARY");
    case "CustomProductItem":
      return translate("CREATE_CUSTOM_ITEM");
    default:
      return "";
  }
};
